import NavigationSidebar from './container';

export default NavigationSidebar;
